import { create } from 'zustand';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useAppStore = create((set, get) => ({
  homeStats: null,
  isLoadingHome: false,
  services: [],
  courses: [],
  teachers: [],
  schools: [],
  articles: [],

  fetchHomeStats: async () => {
    set({ isLoadingHome: true });
    try {
      const response = await axios.get(`${API_URL}/api/home/stats`);
      set({ homeStats: response.data, isLoadingHome: false });
    } catch (error) {
      console.error('Error fetching home stats:', error);
      set({ isLoadingHome: false });
    }
  },

  fetchServices: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/api/services`, { params });
      set({ services: response.data });
      return response.data;
    } catch (error) {
      console.error('Error fetching services:', error);
      return [];
    }
  },

  fetchCourses: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/api/courses`, { params });
      set({ courses: response.data });
      return response.data;
    } catch (error) {
      console.error('Error fetching courses:', error);
      return [];
    }
  },

  fetchTeachers: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/api/teachers`, { params });
      set({ teachers: response.data });
      return response.data;
    } catch (error) {
      console.error('Error fetching teachers:', error);
      return [];
    }
  },

  fetchSchools: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/api/schools`, { params });
      set({ schools: response.data });
      return response.data;
    } catch (error) {
      console.error('Error fetching schools:', error);
      return [];
    }
  },

  fetchArticles: async (params = {}) => {
    try {
      const response = await axios.get(`${API_URL}/api/articles`, { params });
      set({ articles: response.data });
      return response.data;
    } catch (error) {
      console.error('Error fetching articles:', error);
      return [];
    }
  },

  search: async (query, type, city) => {
    try {
      const params = { q: query };
      if (type) params.type = type;
      if (city) params.city = city;
      const response = await axios.get(`${API_URL}/api/search`, { params });
      return response.data;
    } catch (error) {
      console.error('Error searching:', error);
      return { teachers: [], schools: [], services: [], courses: [] };
    }
  },
}));
